export const MODULE_NAME = "organisations";
export const MODULE_UI_NAME = "Organisations"